import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spin, Flex } from 'antd';
import Report from './Report';
import CombinedReport from './CombinedReport';
import InternalReport from './InternalReport/InternalReport';
import { useReportService } from '../../services/reportService';

// Renders a shared link with the same layout the customer sees in their account for that job type
const SharedReport = () => {
    const { sharedLink } = useParams();
    const { getReportBySharedLink } = useReportService();
    // the same language the report itself asks in, so this first request reads the same saved translation
    const { i18n } = useTranslation();

    const [jobType, setJobType] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchJobType = async () => {
            setLoading(true);
            try {
                const job = await getReportBySharedLink(sharedLink, i18n.resolvedLanguage);
                setJobType(job?.type || null);
            } catch (error) {
                console.error('Error fetching shared report:', error?.message);
                setJobType(null);
            } finally {
                setLoading(false);
            }
        };

        fetchJobType();
        // only the job type is read here: a language switch must not show the spinner again (the report page itself
        // asks again in the new language)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sharedLink]);

    if (loading) {
        return (
            <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
                <Spin size="large" />
            </Flex>
        );
    }

    if (jobType === 'combined') return <CombinedReport shared={true} />;
    if (jobType === 'internal') return <InternalReport shared={true} />;

    return <Report shared={true} />;
};

export default SharedReport;
